import { useLocation } from 'react-router-dom';

import { featureFlagsFromUrl, hasFeatureFlag } from 'components/ContentReporting/feature-flags';

export const useFeatureFlags = () => {
  const { search } = useLocation();
  const enabledFeatureFlags = featureFlagsFromUrl(search);

  return {
    isFeatureFlagEnabled: hasFeatureFlag(enabledFeatureFlags),
  };
};

export default useFeatureFlags;
